var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10555",
    "data-name": "Group 10555",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.515,
    height: 20.515,
    viewBox: "0 0 20.515 20.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3054",
    "data-name": "Rectangle 3054",
    width: 20.515,
    height: 20.515,
    fill: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10554",
    "data-name": "Group 10554",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28896",
    "data-name": "Path 28896",
    d: "M15.627,10.742V9.776A3.024,3.024,0,0,0,12.6,6.75,2.954,2.954,0,0,0,9.575,9.776v.966a2.116,2.116,0,0,0-1.4,2.053v2.593a2.168,2.168,0,0,0,2.159,2.159h4.425a2.168,2.168,0,0,0,2.159-2.159V12.795a2.179,2.179,0,0,0-1.293-2.053m-3.893-.966a.856.856,0,0,1,.867-.867.8.8,0,0,1,.867.867v.859H11.735Zm3.026,5.612H10.335V12.795h4.425Z",
    transform: "translate(3.594 2.967)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28897",
    "data-name": "Path 28897",
    d: "M9.717,17.275h-5.4a2.168,2.168,0,0,1-2.159-2.159V6.478H15.116A2.083,2.083,0,0,1,17.169,8.1a1.061,1.061,0,0,0,2.053-.54,4.1,4.1,0,0,0-4.106-3.239H11.444L10.47,2.373A4.19,4.19,0,0,0,6.585,0H4.319A4.335,4.335,0,0,0,0,4.319v10.8a4.335,4.335,0,0,0,4.319,4.319h5.4a1.08,1.08,0,1,0,0-2.159M4.319,2.159H6.585A2.157,2.157,0,0,1,8.531,3.346l.54.973H2.159A2.168,2.168,0,0,1,4.319,2.159",
    fill: "#5a5a5a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccessIcon);
export default __webpack_public_path__ + "static/media/Manage-Access-icon.2905e947b600e74a846e6a06cf0f561e.svg";
export { ForwardRef as ReactComponent };